/* eslint-disable react/no-unknown-property */
import React from 'react';
import PropTypes from 'prop-types';

import styles from './styles.scss';

export const CardMessengers = ({ children, placement = 'card' }) => {
    const arr = React.Children.toArray(children);

    return (
        <div className={styles.root}>
            <ul className={styles.messengersList} count={children.length} id={`${placement}_messengers`}>
                {arr.map((item, index) => (
                    <li key={index}>{item}</li>
                ))}
            </ul>
        </div>
    );
};

CardMessengers.propTypes = {
    children: PropTypes.any,
    placement: PropTypes.string,
};
